







import {Vue, Component} from 'vue-property-decorator';
import GridLayoutsPopup from '@/components/tuigrid/GridLayoutsPopup.vue';

@Component
export default class JudgementListSlotRight extends Vue {
  private configOption: any[];

  onClickConfig(): void {
    let LayerPop = Vue.extend(GridLayoutsPopup);
    let pop = new LayerPop({
      propsData: {
        defaultDisplayOrder: this.defaultDisplayOrder,
        configOption: this.configOption,
        label: 'JUDGEMENT'
      },
      model: {
        prop: 'configOption',
        event: 'configOption'
      }
    });
    pop.$t = window.$t;
    this.$eventBus.$emit('LAYER-POP-OPEN', pop);
  }

  private getStr(str: string): string {
    return '' + this.$t(str);
  }

  private getDisplayName(str: string): string {
    switch (str) {
      case 'applyStatus':
        str = this.getStr('PRODUCT_PRODUCT_ADMIT_STATUS');
        break;
      case 'mallName':
        str = this.getStr('PRODUCT_PRODUCT_MALL_NAME');
        break;
      case 'productNo':
        str = this.getStr('PRODUCT_PRODUCT_MALL_PRODUCT_NO');
        break;
      case 'productName':
        str = this.getStr('PRODUCT_PRODUCT_PRODUCT_NAME');
        break;
      case 'managementCode':
        str = this.getStr('PRODUCT_PRODUCT_PRODUCT_MANAGEMENT_CD');
        break;
      case 'brandName':
        str = this.getStr('PRODUCT_PRODUCT_BRAND');
        break;
      case 'partnerName':
        str = this.getStr('PRODUCT_PRODUCT_PARTNER_NAME');
        break;
      case 'representativeName':
        str = this.getStr('PRODUCT_PRODUCT_ADMIN_NAME');
        break;
      case 'commissionRate':
        str = this.getStr('PRODUCT_PRODUCT_COMMISSION_RATE');
        break;
      case 'saleDateTime':
        str = this.getStr('PRODUCT_PRODUCT_SALE_PERIOD');
        break;
      case 'approvalRequestedDateTime':
        str = this.getStr('PRODUCT_PRODUCT_APPROVAL_REQUESTED_DATETIME');
        break;
      case 'registerDateTime':
        str = this.getStr('PRODUCT_PRODUCT_PRODUCT_REGISTER');
        break;
    }

    return str;
  }

  private getDisabled(name: string): boolean {
    let disabled: boolean;
    disabled = ['applyStatus', 'mallName', 'productNo', 'productName'].includes(name);
    return disabled;
  }

  private getGridData() {
    this.$api.getGridLayouts({params: {gridName: 'PRODUCT_JUDGEMENT_GRID'}}).then(({data}): any => {
      if (data.length === 0) {
        Object.assign(data, this.defaultDisplayOrder);
      }
      this.configOption = data.map(d => ({
        name: d.columnName,
        order: d.displayOrder,
        visible: d.visible,
        displayName: this.getDisplayName(d.columnName),
        disabled: this.getDisabled(d.columnName)
      }));
    });
  }

  private defaultDisplayOrder = [
    {
      columnName: 'applyStatus',
      order: 1,
      visible: true,
      displayName: this.getStr('PRODUCT_PRODUCT_ADMIT_STATUS'),
      disabled: true
    },
    {
      columnName: 'mallName',
      order: 2,
      visible: true,
      displayName: this.getStr('PRODUCT_PRODUCT_MALL_NAME'),
      disabled: true
    },
    {
      columnName: 'productNo',
      order: 3,
      visible: true,
      displayName: this.getStr('PRODUCT_PRODUCT_MALL_PRODUCT_NO'),
      disabled: true
    },
    {
      columnName: 'productName',
      order: 4,
      visible: true,
      displayName: this.getStr('PRODUCT_PRODUCT_PRODUCT_NAME'),
      disabled: true
    },
    {
      columnName: 'managementCode',
      order: 5,
      visible: true,
      displayName: this.getStr('PRODUCT_PRODUCT_PRODUCT_MANAGEMENT_CD'),
      disabled: false
    },
    {
      columnName: 'brandName',
      order: 6,
      visible: true,
      displayName: this.getStr('PRODUCT_PRODUCT_BRAND'),
      disabled: false
    },
    {
      columnName: 'partnerName',
      order: 7,
      visible: true,
      displayName: this.getStr('PRODUCT_PRODUCT_PARTNER_NAME'),
      disabled: false
    },
    {
      columnName: 'representativeName',
      order: 8,
      visible: true,
      displayName: this.getStr('PRODUCT_PRODUCT_ADMIN_NAME'),
      disabled: false
    },
    {
      columnName: 'commissionRate',
      order: 9,
      visible: true,
      displayName: this.getStr('PRODUCT_PRODUCT_COMMISSION_RATE'),
      disabled: false
    },
    {
      columnName: 'saleDateTime',
      order: 10,
      visible: true,
      displayName: this.getStr('PRODUCT_PRODUCT_SALE_PERIOD'),
      disabled: false
    },
    {
      columnName: 'approvalRequestedDateTime',
      order: 10,
      visible: true,
      displayName: this.getStr('PRODUCT_PRODUCT_APPROVAL_REQUESTED_DATETIME'),
      disabled: false
    },
    {
      columnName: 'registerDateTime',
      order: 10,
      visible: true,
      displayName: this.getStr('PRODUCT_PRODUCT_PRODUCT_REGISTER'),
      disabled: false
    }
  ];

  private created() {
    this.getGridData();
  }
}
